module.exports = "data:image/png;base64,H4sICDaZs1oAC2RpYWdvbmFscy1tZWRpdW0ucG5nAOsM8HPn5ZLiYmBg4PX0cAkC0hogzMgMJLcZaOkBKeZiJ88QDg6O2w/9HwC5bAE+Ia7///8HMkMPXa4DUpwFHpHFDAzcQiDMeOlu3R+goFiJa0SJc1FqYklmfp5CSGZuKoOBpT4QGRrOCHzzDqhCBqQiOD+tpDyxKJXBMSU/KVXBLbMotTy/KLtYwTnYtHDrYzOQYzxdHEM4ZiZPYGZkkxZIWMHA2MavcOCDAIsEXzODszWHwYdmhsMC4fwMGkrJcycvNjcE6mHwdPVzWeeU0AQAEjU4keEAAAA="


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/diagonals-medium.png
// module id = ../../../../../client/assets/img/diagonals-medium.png
// module chunks = styles